import { z } from 'zod';
import { UuidString } from '../../primitives.js';

/**
 * F14 (work-tasks-user-feedback §3.3) — родитель строки выдачи, которого в выдаче нет.
 *
 * Дерево задач собирается пересечением `parent_task_id` с полученными строками,
 * поэтому этап, вырезанный фильтром (отменённый — при фильтре по умолчанию), уносит
 * не только себя: его живые дети всплывают КОРНЯМИ, и план со стороны выглядит
 * рассыпавшимся (жалоба Д-4/UF-3). Назвать такой этап фронт не может — его строки
 * в ответе нет, поэтому имя приходит отдельным справочником рядом с `tasks[]`.
 *
 * Статус здесь же: крошка «В этапе X» без пометки «отменён» объясняет вложенность,
 * но не объясняет пропажу.
 */
export const DetachedParentEntry = z.object({
  task_id: UuidString,
  title: z.string(),
  state_name: z.string().nullable().optional(),
  state_color_token: z.string().nullable().optional(),
  state_group: z.string().nullable().optional(),
});
export type DetachedParentEntry = z.infer<typeof DetachedParentEntry>;

export const DetachedParentDirectory = z.array(DetachedParentEntry);
export type DetachedParentDirectory = z.infer<typeof DetachedParentDirectory>;
